import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from '../ui/card';
import { cardAnimation } from './animations';

export const FeatureCard = ({ icon: Icon, title, description, index, variant = 'default' }) => {
  return (
    <motion.div {...cardAnimation(index)}>
      <Card className="h-full glass-card border-border/50 hover:border-primary/30 transition-all duration-300 group">
        <CardContent className="p-6 flex flex-col items-start gap-4">
          <div
            className={`p-3 rounded-xl ${
              variant === 'destructive'
                ? 'bg-destructive/10 group-hover:bg-destructive/20'
                : 'bg-primary/10 group-hover:bg-primary/20'
            } transition-colors duration-300`}
          >
            <Icon className={`w-6 h-6 ${variant === 'destructive' ? 'text-destructive' : 'text-primary'}`} />
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-2 text-foreground">{title}</h3>
            <p className="text-sm text-muted-foreground">{description}</p>
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
};
